module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "role": "tabpanel"
    }
  }, [_c('ul', {
    staticClass: "tab-nav",
    attrs: {
      "data-tab-color": "teal",
      "role": "tablist"
    }
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      staticClass: "tab-pane",
      class: {
        active: tab.active
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeTab(index)
        }
      }
    }, [(tab.icon && tab.icon.length > 0) ? _c('i', {
      staticClass: "m-r-5",
      class: tab.icon
    }) : _vm._e(), _vm._v(_vm._s(tab.title))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e27f52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tab/tabcontain.vue
// module id = 556
// module chunks = 23